import { Pipe, PipeTransform } from '@angular/core';
import { Contact } from '../../contacts/contracts/contact.interface';

@Pipe({
  name: 'contactAvatar'
})
export class ContactAvatarPipe implements PipeTransform {

  transform(contact: Contact | null | undefined): string | null {
    if (!contact) {
      return null;
    }

    const first = contact.firstName?.trim();
    const last = contact.lastName?.trim();
    const company = contact.companyName?.trim();

    if (first && last) {
      return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
    }

    if (company) {
      const words = company.split(/\s+/);
      return words.length >= 2
        ? `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase()
        : company.substring(0, 2).toUpperCase();
    }

    return null;
  }
}
